import { jsPDF } from "jspdf";
import { getFormattedDate, saveFile } from "@/components/reports/fileMethods";
import { getFacesArea } from "@/components/geometry/geometryLoader";
import { getImgDataForCurrentView } from "@/components/reports/ReportsManager";
import { getMeshesBox } from "@/components/anchorage/AnchorageCalculation";
import { getTeethBox, getTeethZoom } from "../occlusal/OcclusalTools.js";
import {
  currentTreatmentStageId,
  applyTreatmentStage,
} from "./treatment/OrthoTreatment";

import {
  findTeethAnchorageLoss,
  findTeethCollisions,
  findAngulations,
  clearOrtoAccesories,
  OrthoPlanMode,
  toothContext,
} from "./OrthoPlanMode";
import { drawLine } from "../draw/draw.js";
import AnatomyReportDialog from "./AnatomyReportDialog.vue";
import { generateRootCrownMeshes } from "@/components/anchorage/AnchorageCalculation.js";

//#region Fields

const fontSize = 14;
const textLeft = 8;
const lineHeightFactor = 0.7;
const itemHeight = 70;
const itemsGap = 10;

const toothOpacity = 0.4;

let allTeethBox = null;
let allTeethCenter = null;

let maxBox = null;
let maxCenter = null;

let mandBox = null;
let mandCenter = null;

let view_dy = 3;
let view_dz = 6;
let cameraDistance = 32;

let controlsInitialized = false;

//#endregion

function initializeControls() {
  if (!controlsInitialized) {
    var ctrls = [AnatomyReportDialog];
    ctrls.forEach((component) => {
      const componentInstance = new Vue({
        ...component,
        propsData: { mode: null },
      });
      const vueContainer = document.createElement("div");
      document.getElementById("stl_wrapper").appendChild(vueContainer);
      componentInstance.$mount(vueContainer);
    });
    controlsInitialized = true;
  }
}

function anatomyChangeReport() {
  initializeControls();
  $("#anatomyReportDialog").modal();
  $("#reportAnchorageLossDiv").css(
    "display",
    vueApp.isTreatmentPlayMode ? "none" : "block",
  );
}

function createAnatomyChangeReport(reportSetups) {
  if (vueApp.isTreatmentPlayMode && reportSetups)
    reportSetups.isAnchorageLoss = false;
  console.log("createAnatomyChangeReport", reportSetups);

  // vueApp.leaveModes(true, false, false);
  vueApp.saveCameraView();
  showLoader(false);

  setTimeout(async () => {
    if (reportSetups.isAnchorageLoss) generateRootCrownMeshes();

    // viewer.scene.background = new THREE.Color("#77a7fd");
    setCenters();
    clearOrtoAccesories();

    let data = await prepareAnatomyChangeData(reportSetups);
    generateAnatomyChangePdf(data, reportSetups);
    clearOrtoAccesories();
    hideLoader();
    // vueApp.switchToDefaultView();
    vueApp.switchToSavedCameraView();
    vueApp.resetVisibilityAndOpacity();
    viewer.do_resize();
  }, 100);
}

function setCenters() {
  if (!maxCenter || !mandCenter) {
    allTeethBox = offsetBox(getMeshesBox(vueApp.teethMeshes));
    allTeethCenter = new THREE.Vector3(
      allTeethBox.center.x,
      allTeethBox.center.y,
      allTeethBox.center.z,
    );

    maxBox = offsetBox(getTeethBox(true));
    maxCenter = new THREE.Vector3(
      maxBox.center.x,
      maxBox.min.y + view_dy,
      maxBox.min.z + view_dz * 2,
    );
    // maxillaCenter = new THREE.Vector3(
    //   maxillaBox.center.x,
    //   maxillaBox.center.y, // + 5,
    //   maxillaBox.center.z
    // );

    mandBox = offsetBox(getTeethBox(false));
    mandCenter = new THREE.Vector3(
      mandBox.center.x,
      mandBox.max.y - view_dy * 1.8,
      mandBox.min.z + view_dz * 2,
    );
    // mandibleCenter = new THREE.Vector3(
    //   mandibleBox.center.x,
    //   mandibleBox.center.y, // - 10,
    //   mandibleBox.center.z
    // );
  }
}

async function prepareAnatomyChangeData(reportSetups) {
  let data = {
    anchorageLosses: [],
    originalAngulations: {},
    teethAngulations: {},
    teethCollisions: {},
  };

  if (vueApp.isTreatmentPlayMode) {
    let currentStageId = +currentTreatmentStageId;
    applyTreatmentStage(0);
    showLoader(false);

    if (reportSetups.isAngulation) {
      data.originalAngulations = findAngulations(0, true);
    }

    if (currentStageId === 0) {
      let maxId = vueApp.getMaxTreatmentStageId();
      applyTreatmentStage(maxId);
    } else {
      applyTreatmentStage(currentStageId);
    }
  }
  showLoader(false);
  if (reportSetups.isAngulation) {
    data.teethAngulations = findAngulations(reportSetups.angulationAngle);
    let angulationKeys = Object.keys(data.teethAngulations);
    for (const key of angulationKeys) {
      let item = data.teethAngulations[key];
      item.angle = Math.round(item.angle);
      item.original = data.originalAngulations
        ? data.originalAngulations[key]
        : null;
      if (item.original) {
        item.original.angle = Math.round(item.original.angle);
        console.log("angulation", item);
        if (item.original.angle == item.angle) {
          data.teethAngulations[key] = null;
          continue;
        }
      }
      prepareViewToAngulationObj(item);
      await new Promise((r) => setTimeout(r, 200));
      item.imgData = getImgDataForCurrentView();
    }
  }
  if (reportSetups.isAnchorageLoss) {
    findTeethAnchorageLoss();
  }
  if (reportSetups.isCollision) {
    findTeethCollisions();
  }

  for (const tooth of vueApp.allTeeth) {
    let mesh = viewer.get_model_mesh(tooth.id);
    if (mesh) {
      if (mesh.crossedMeshes && mesh.crossedMeshes.length) {
        for (const cmesh of mesh.crossedMeshes) {
          let modelArr = [cmesh.model1, cmesh.model2];
          modelArr.sort((m1, m2) => m1.number - m2.number);
          let collisionKey = `${modelArr[0].number}-${modelArr[1].number}`;
          let facesArea = getFacesArea(cmesh.geometry);
          // let box = offsetBox(cmesh.geometry.boundingBox);
          if (
            !data.teethCollisions[collisionKey] &&
            facesArea >= reportSetups.collisionArea
          ) {
            console.log("collisionKey mm2", collisionKey, facesArea);
            let collisionObj = {
              mesh: cmesh,
              models: modelArr,
              model1: modelArr[0],
              model2: modelArr[1],
              imgData: null,
              facesArea: facesArea,
            };

            prepareViewToCollisionObj(collisionObj);
            await new Promise((r) => setTimeout(r, 200));
            collisionObj.imgData = getImgDataForCurrentView();
            data.teethCollisions[collisionKey] = collisionObj;
          }
        }
      }

      if (mesh.anchorageLossMesh && mesh.rootArea) {
        let facesArea = getFacesArea(mesh.anchorageLossMesh.geometry);
        let percent = Math.round((facesArea * 100) / mesh.rootArea);
        if (percent >= reportSetups.anchorageLoss) {
          // facesArea >= 0.5 &&
          // console.log("anchorageLossMesh %", tooth.filename, percent);
          let anchorageLoss = {
            number: tooth.number,
            tooth: tooth,
            imgData: null,
            facesArea: facesArea,
            rootArea: mesh.rootArea,
            percent: percent,
          };

          prepareViewToAnchorageLoss(tooth);
          await new Promise((r) => setTimeout(r, 200));
          anchorageLoss.imgData = getImgDataForCurrentView();
          data.anchorageLosses.push(anchorageLoss);
        }
      }
    }
  }

  console.log("prepareAnatomyChangeData", data);
  return data;
}

function hideAuxilaryMeshes(mesh) {
  if (toothContext) toothContext.tooth = null;
  if (mesh.moveRotateGroup) {
    mesh.moveRotateGroup.visible = false;
  }
  if (mesh.crossedMeshes) {
    mesh.crossedMeshes.forEach((crossedMesh) => {
      crossedMesh.visible = false;
    });
  }
  if (mesh.anchorageLossMesh) {
    mesh.anchorageLossMesh.visible = false;
  }
  if (mesh.axisMesh) {
    mesh.axisMesh.visible = false;
  }
  if (mesh.originalTreatmentMesh) {
    mesh.originalTreatmentMesh.visible = false;
  }
}

function prepareViewToAngulationObj(angulationItem) {
  vueApp.allItems.forEach((model) => {
    let mesh = viewer.get_model_mesh(model.id);
    mesh.visible = angulationItem.models.includes(model);
    if (mesh.visible) {
      let material = mesh.originalMaterial
        ? mesh.originalMaterial
        : mesh.material;
      material.opacity = toothOpacity;
      material.side = THREE.FrontSide;
    }
    hideAuxilaryMeshes(mesh);
    if (mesh.axisMesh) {
      mesh.axisMesh.visible = mesh.visible;
    }
  });
  // collisionObj.mesh.visible = true;

  let e = viewer.parent_element.getBoundingClientRect();
  let t = e.width;
  let a = t * 0.7;
  viewer.camera.aspect = t / a;
  viewer.camera.updateProjectionMatrix();
  viewer.renderer.setSize(t, a);

  vueApp.lookAtPoint({ x: 0, y: 0, z: 0 });
  resetCameraUp();

  let tooth1 = angulationItem.model1;
  setToothPointsOfView(tooth1);
  let tooth2 = angulationItem.model2;
  setToothPointsOfView(tooth2);

  let toothMesh1 = viewer.get_model_mesh(tooth1.id);
  let toothMesh2 = viewer.get_model_mesh(tooth2.id);

  let cpoint1 = toothMesh1.cameraPoint;
  let cpoint2 = toothMesh2.cameraPoint;
  let centerCameraPoint = new THREE.Vector3(
    (cpoint1.x + cpoint2.x) / 2,
    (cpoint1.y + cpoint2.y) / 2,
    (cpoint1.z + cpoint2.z) / 2,
  );
  viewer.camera.position.copy(centerCameraPoint);

  let pos1 = toothMesh1.position;
  let pos2 = toothMesh2.position;
  let centerPosPoint = new THREE.Vector3(
    (pos1.x + pos2.x) / 2,
    (pos1.y + pos2.y) / 2,
    (pos1.z + pos2.z) / 2,
  );
  vueApp.lookAtPoint(centerPosPoint);

  viewer.camera.updateProjectionMatrix();
  viewer.controls.update();
}

function prepareViewToCollisionObj(collisionObj) {
  vueApp.allItems.forEach((model) => {
    let mesh = viewer.get_model_mesh(model.id);
    mesh.visible = collisionObj.models.includes(model);
    if (mesh.visible) {
      let material = mesh.originalMaterial
        ? mesh.originalMaterial
        : mesh.material;
      material.opacity = toothOpacity;
      material.side = THREE.FrontSide;
    }
    hideAuxilaryMeshes(mesh);
  });
  collisionObj.mesh.visible = true;

  let e = viewer.parent_element.getBoundingClientRect();
  let t = e.width;
  let a = t * 0.7;
  viewer.camera.aspect = t / a;
  viewer.camera.updateProjectionMatrix();
  viewer.renderer.setSize(t, a);

  vueApp.lookAtPoint({ x: 0, y: 0, z: 0 });
  resetCameraUp();

  let tooth1 = collisionObj.model1;
  setToothPointsOfView(tooth1);
  let tooth2 = collisionObj.model2;
  setToothPointsOfView(tooth2);

  let toothMesh1 = viewer.get_model_mesh(tooth1.id);
  let toothMesh2 = viewer.get_model_mesh(tooth2.id);
  let cpoint1 = toothMesh1.cameraPoint;
  let cpoint2 = toothMesh2.cameraPoint;

  let centerCameraPoint = new THREE.Vector3(
    (cpoint1.x + cpoint2.x) / 2,
    (cpoint1.y + cpoint2.y) / 2,
    (cpoint1.z + cpoint2.z) / 2,
  );

  viewer.camera.position.copy(centerCameraPoint);

  let vcenter = collisionObj.mesh.center;
  vueApp.lookAtPoint(vcenter);

  viewer.camera.updateProjectionMatrix();
  viewer.controls.update();
}

function setToothPointsOfView(tooth) {
  // console.log("setPointOfView", tooth.filename);
  let mesh = viewer.get_model_mesh(tooth.id);

  if (mesh && tooth.defaultBox) {
    let center = tooth.isMaxilla ? maxCenter : mandCenter;
    let toothBox = tooth.defaultBox;

    let x = toothBox.center.x;
    // let y = tooth.isMaxilla ? toothBox.min.y + view_dy : toothBox.max.y - view_dy * 1.8;
    let y = tooth.isMaxilla ? toothBox.min.y + view_dy : toothBox.max.y;
    let z = toothBox.center.z;
    mesh.apexCenter = new THREE.Vector3(x, y, z);

    let distance = calculateDistance(mesh.apexCenter, center);
    let coef = (distance + cameraDistance) / distance;
    let px = (x - center.x) * coef + center.x;
    let py = (y - center.y) * coef + center.y;
    let pz = (z - center.z) * coef + center.z;
    mesh.cameraPoint = new THREE.Vector3(px, py, pz);
    // drawLine(mesh.position, mesh.cameraPoint);
  }
}

function prepareViewToAnchorageLoss(tooth) {
  let toothMesh = null;
  vueApp.allItems.forEach((model) => {
    let mesh = viewer.get_model_mesh(model.id);
    mesh.visible = tooth == model;
    hideAuxilaryMeshes(mesh);
    if (mesh.anchorageLossMesh) {
      mesh.anchorageLossMesh.visible = mesh.visible;
    }
    if (mesh.visible) {
      toothMesh = mesh;
    }
  });

  let material = toothMesh.originalMaterial
    ? toothMesh.originalMaterial
    : toothMesh.material;
  material.opacity = toothOpacity;
  material.side = THREE.FrontSide;

  vueApp.bones.forEach((model) => {
    let mesh = viewer.get_model_mesh(model.id);
    mesh.visible = model.isUpper == tooth.isUpper;
    if (mesh.visible) {
      mesh.material.opacity = 0.7;
    }
  });

  let e = viewer.parent_element.getBoundingClientRect();
  let t = e.width;
  let a = t * 0.7;
  viewer.camera.aspect = t / a;
  viewer.camera.updateProjectionMatrix();
  viewer.renderer.setSize(t, a);

  vueApp.lookAtPoint({ x: 0, y: 0, z: 0 });
  resetCameraUp();

  setToothPointsOfView(tooth);
  let vcenter = toothMesh.position;
  let centerCameraPoint = toothMesh.cameraPoint;
  viewer.camera.position.copy(centerCameraPoint);

  vueApp.lookAtPoint(vcenter);

  viewer.camera.updateProjectionMatrix();
  viewer.controls.update();
}

function generateAnatomyChangePdf(data, reportSetups) {
  console.log("generateAnatomyChangePdf", data);

  const pdf = new jsPDF();
  const pdfWidth = pdf.internal.pageSize.getWidth(); // 210
  const pdfHeight = pdf.internal.pageSize.getHeight(); // 297
  pdf.setFont("helvetica");
  const heightMargin = 30;

  let nextTop = 0;

  if (
    !reportSetups.isAnchorageLoss &&
    !reportSetups.isCollision &&
    !reportSetups.isAngulation
  ) {
    nextTop = addHeaderToPdf(pdf, "No Selected Options", pdfWidth);
  }

  if (reportSetups.isAnchorageLoss) {
    nextTop = addHeaderToPdf(pdf, "Anchorage Loss", pdfWidth);
    if (data.anchorageLosses.length == 0) {
      nextTop = addInfoTextToPdf(pdf, `There is no anchorage loss`, nextTop);
    } else {
      for (const item of data.anchorageLosses) {
        if (nextTop + itemHeight + heightMargin > pdfHeight) {
          pdf.addPage();
          nextTop = heightMargin;
        }

        nextTop = addAnchorageLossToPdf(pdf, item, nextTop, pdfWidth);
      }
    }

    pdf.addPage();
  }

  if (reportSetups.isCollision) {
    nextTop = addHeaderToPdf(pdf, "Root Collisions", pdfWidth);
    let collisionKeys = Object.keys(data.teethCollisions);
    if (collisionKeys.length == 0) {
      nextTop = addInfoTextToPdf(pdf, `There are no root collisions`, nextTop);
    } else {
      for (const key of collisionKeys) {
        if (nextTop + itemHeight + heightMargin > pdfHeight) {
          pdf.addPage();
          nextTop = heightMargin;
        }
        let item = data.teethCollisions[key];
        nextTop = addRootCollisonToPdf(pdf, item, nextTop, pdfWidth);
      }
    }

    pdf.addPage();
  }

  if (reportSetups.isAngulation) {
    let counter = 0;
    let angulationKeys = Object.keys(data.teethAngulations);
    nextTop = addHeaderToPdf(pdf, "Root Angulations", pdfWidth);
    for (const key of angulationKeys) {
      if (nextTop + itemHeight + heightMargin > pdfHeight) {
        pdf.addPage();
        nextTop = heightMargin;
      }
      let item = data.teethAngulations[key];
      if (item) {
        nextTop = addAngulationToPdf(pdf, item, nextTop, pdfWidth);
        counter++;
      }
    }

    if (counter === 0) {
      nextTop = addInfoTextToPdf(pdf, `There are no root angulations`, nextTop);
    }
  }

  let fullName = `anatomyChangeReport_${getFormattedDate(true)}.pdf`;
  pdf.save(fullName);
}

function addAngulationToPdf(pdf, item, nextTop, pdfWidth) {
  let angle = Math.round(item.angle);

  let text = `Teeth ${item.model1.number} and ${item.model2.number}: `; // have a low angle inclination of ${item.angle} degrees`;
  pdf.setFontSize(fontSize);
  let textDims = pdf.getTextDimensions(text);
  let textHeight = textDims.h;

  let textTop = nextTop + itemHeight / 2 - textHeight;
  pdf.text(text, textLeft, textTop);
  textTop += textHeight * 2;

  if (item.original && item.original.angle) {
    let originalAngle = Math.round(item.original.angle);
    text = `- angulation changed from ${originalAngle}° to ${angle}°`;
  } else {
    text = `- a low angle inclination of ${angle}°`;
  }
  pdf.text(text, textLeft, textTop);

  let imgData = item.imgData;
  let imgProps = pdf.getImageProperties(imgData);

  let imgMaxWidth = pdfWidth / 2;
  let imgMaxHeight = itemHeight;
  let imgWidthRel = imgMaxWidth / imgProps.width;
  let imgHeightRel = imgMaxHeight / imgProps.height;
  let imgMinRel = Math.min(imgWidthRel, imgHeightRel);
  let imgWidth = imgProps.width * imgMinRel;
  let imgHeight = imgProps.height * imgMinRel;

  let imgLeft = pdfWidth / 2 - textLeft;
  let imgTop = nextTop;
  pdf.addImage(imgData, "JPEG", imgLeft, imgTop, imgWidth, imgHeight);

  return nextTop + itemHeight + itemsGap;
}

function addRootCollisonToPdf(pdf, item, nextTop, pdfWidth) {
  // TODO number
  let text = `Teeth ${item.model1.number} and ${item.model2.number} display collision`;
  pdf.setFontSize(fontSize);
  let textDims = pdf.getTextDimensions(text);
  let textHeight = textDims.h;
  let textWidth = textDims.w;

  let textTop = nextTop + itemHeight / 2 - textHeight / 2;
  pdf.text(text, textLeft, textTop);

  let imgData = item.imgData;
  let imgProps = pdf.getImageProperties(imgData);

  let imgMaxWidth = pdfWidth / 2;
  let imgMaxHeight = itemHeight;
  let imgWidthRel = imgMaxWidth / imgProps.width;
  let imgHeightRel = imgMaxHeight / imgProps.height;
  let imgMinRel = Math.min(imgWidthRel, imgHeightRel);
  let imgWidth = imgProps.width * imgMinRel;
  let imgHeight = imgProps.height * imgMinRel;

  let imgLeft = pdfWidth / 2 - textLeft;
  let imgTop = nextTop;
  pdf.addImage(imgData, "JPEG", imgLeft, imgTop, imgWidth, imgHeight);

  return nextTop + itemHeight + itemsGap;
}

function addAnchorageLossToPdf(pdf, item, nextTop, pdfWidth) {
  // let imgData = item.imgData; //  displays an 18% bone anchorage loss
  let text = `Tooth ${item.number} displays an ${item.percent}% bone`;
  pdf.setFontSize(fontSize);
  let textDims = pdf.getTextDimensions(text);
  let textHeight = textDims.h;
  let textWidth = textDims.w;

  let textTop = nextTop + itemHeight / 2 - textHeight / 2;
  pdf.text(text, textLeft, textTop);

  textTop += textHeight * 2;
  text = `anchorage loss`;
  pdf.text(text, textLeft, textTop);

  let imgData = item.imgData;
  let imgProps = pdf.getImageProperties(imgData);

  let imgMaxWidth = pdfWidth / 2;
  let imgMaxHeight = itemHeight;
  let imgWidthRel = imgMaxWidth / imgProps.width;
  let imgHeightRel = imgMaxHeight / imgProps.height;
  let imgMinRel = Math.min(imgWidthRel, imgHeightRel);
  let imgWidth = imgProps.width * imgMinRel;
  let imgHeight = imgProps.height * imgMinRel;

  let imgLeft = pdfWidth / 2 - textLeft; // textLeft + textWidth + textLeft;
  let imgTop = nextTop;
  pdf.addImage(imgData, "JPEG", imgLeft, imgTop, imgWidth, imgHeight);

  return nextTop + itemHeight + itemsGap;
}

function addHeaderToPdf(pdf, headerText, pdfWidth) {
  pdf.setFontSize(18);
  // let headerText = "Root Collisions";
  let headerDims = pdf.getTextDimensions(headerText);
  let headerWidth = headerDims.w;
  let headerHeight = headerDims.h;
  let headerTop = headerHeight * 2;
  let headerLeft = pdfWidth / 2 - headerWidth / 2;
  pdf.text(headerText, headerLeft, headerTop);
  return headerTop + headerHeight * 2;
}

function addInfoTextToPdf(pdf, text, textTop) {
  pdf.setFontSize(fontSize);
  let textDims = pdf.getTextDimensions(text);
  let textHeight = textDims.h;
  let lineHeight = textHeight * 2 * lineHeightFactor;
  pdf.text(text, textLeft, textTop);
  return textTop + lineHeight;
}

function showLoader(isGray) {
  $id("loader").style.display = "block";
  if (isGray) {
    $id("loader").style.background = "transparent";
    $id("loader").style.opacity = "0.7";
  }
  $("#loaderText").html(`Data calculation... Please wait`);
  $("#loaderText2").html(``);
  $("#loaderText3").html(``);
  let canvas = viewer.renderer.domElement;
  canvas.setAttribute("hidden", "hidden");
  vueApp.isHidden = true;
}

function hideLoader() {
  $id("loader").style.display = "none";
  let canvas = viewer.renderer.domElement;
  canvas.removeAttribute("hidden");
  vueApp.isHidden = false;
}

export { anatomyChangeReport, createAnatomyChangeReport };
